import { create } from "zustand";

type PanelMode = "context" | "milestones";

interface BrandContextPanelState {
  isOpen: boolean;
  mode: PanelMode;
  scrollToMilestones: boolean;
  open: () => void;
  openMilestones: () => void;
  openToMilestones: () => void;
  close: () => void;
  clearScrollTarget: () => void;
}

export const useBrandContextPanel = create<BrandContextPanelState>((set) => ({
  isOpen: false,
  mode: "context",
  scrollToMilestones: false,
  open: () => set({ isOpen: true, mode: "context", scrollToMilestones: false }),
  openMilestones: () => set({ isOpen: true, mode: "milestones", scrollToMilestones: false }),
  openToMilestones: () => set({ isOpen: true, mode: "context", scrollToMilestones: true }),
  close: () => set({ isOpen: false, scrollToMilestones: false }),
  clearScrollTarget: () => set({ scrollToMilestones: false }),
}));
